import { IconProps } from "./Icon.model";

export function Home03Icon({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9992 16C13.3101 16 14.3465 17.1123 14.2531 18.4199L14.2521 18.4277L14.0119 22.748C13.7476 22.7487 13.4737 22.75 13.1896 22.75H10.8117C10.5267 22.75 10.2515 22.7487 9.98648 22.748L9.74722 18.4277L9.74625 18.4199C9.65285 17.1124 10.6884 16.0002 11.9992 16ZM12.0002 1.25C12.8662 1.25 13.6408 1.52703 14.4767 1.99609C15.2865 2.45052 16.2144 3.1213 17.381 3.96484L18.8908 5.05664C19.8269 5.73348 20.5748 6.27401 21.1388 6.77441C21.7213 7.29124 22.1573 7.80701 22.4337 8.45508C22.7108 9.10463 22.7785 9.77046 22.7414 10.5381C22.7055 11.2789 22.5679 12.1726 22.3966 13.2871L22.0812 15.3389C21.8379 16.9225 21.6442 18.1836 21.3595 19.166C21.0652 20.1819 20.6505 20.989 19.9093 21.6055C19.1712 22.2194 18.2911 22.4926 17.217 22.623C16.8514 22.6674 16.4523 22.6951 16.0168 22.7139L16.2482 18.5537C16.4191 16.0921 14.4679 14 11.9992 14C9.53059 14.0002 7.5802 16.0922 7.75113 18.5537L7.9816 22.7139C7.54678 22.6951 7.14837 22.6674 6.78336 22.623C5.70934 22.4926 4.83006 22.2193 4.09195 21.6055C3.3507 20.9889 2.93615 20.182 2.64175 19.166C2.35706 18.1835 2.16246 16.9226 1.9191 15.3389L1.60465 13.2871C1.43336 12.1726 1.29579 11.2789 1.25992 10.5381C1.22275 9.77046 1.28952 9.10463 1.56656 8.45508C1.843 7.80696 2.27895 7.29127 2.86148 6.77441C3.42564 6.2739 4.17411 5.73367 5.1105 5.05664L6.61929 3.96484C7.78616 3.12114 8.71472 2.45055 9.52457 1.99609C10.3603 1.52716 11.1342 1.25003 12.0002 1.25Z"
        fill={fillColor}
      />
    </svg>
  );
}
